import { StyleSheet } from "aphrodite";
import theme from "../../../common/theme/mellon";

export default StyleSheet.create({
  dynamicFieldsContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "20px",
  },
  container: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    "@media (max-width: 799px)": {
      alignItems: "center",
    },
  },
  labelContainer: {
    display: "flex",
    width: "100%",
    maxWidth: "400px",
  },
  labelText: {
    fontSize: "14px",
    color: theme.palette.primary.dark,
    lineHeight: 1.4,
  },
  numberFieldGroup: {
    display: "flex",
    width: "100%",
    maxWidth: "400px",
    alignItems: "stretch",
  },
  numberInputWrapper: {
    display: "flex",
    flex: 1,
    background: theme.colors.white,
    border: "1px solid " + theme.palette.primary.dark,
    borderRadius: "4px 0 0 4px",
    overflow: "hidden",
    minHeight: "40px",
  },
  numberInputWrapperRounded: {
    borderRadius: "4px",
  },
  numberInputError: {
    borderColor: theme.palette.error.main,
  },
  numberInput: {
    flex: 1,
    border: "none",
    outline: "none",
    padding: "8px 12px",
    fontSize: "16px",
    width: "100%",
    background: "transparent",
    color: theme.palette.primary.dark,
    MozAppearance: "textfield",
  },
  stepper: {
    display: "flex",
    flexDirection: "column",
    borderLeft: "1px solid " + theme.palette.primary.dark,
    background: theme.colors.white,
  },
  stepperButton: {
    borderRadius: "0 !important",
    padding: "0 !important",
    minWidth: "32px !important",
    height: "20px !important",
    color: theme.palette.primary.dark,
  },
  stepperButtonTop: {
    borderBottom: "1px solid " + theme.palette.primary.dark,
  },
  suffixAddon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 16px",
    minWidth: "56px",
    background: theme.colors.white,
    border: "1px solid " + theme.palette.primary.dark,
    borderLeft: "none",
    borderRadius: "0 4px 4px 0",
    color: theme.palette.primary.dark,
  },
  switchWrapper: {
    alignItems: "center",
    padding: "0 8px",
  },
  switchLabel: {
    color: theme.palette.primary.dark,
  },
  error: {
    borderColor: theme.palette.error.main,
  },
  errorField: {
    maxWidth: "400px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  errorText: {
    color: theme.palette.error.main,
  },
});
